import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const FeaturesSection = styled.section`
  padding: 100px 0;
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a2e 100%);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled(motion.h2)`
  font-family: "Playfair Display", serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  text-align: center;
  color: #ffffff;
  margin-bottom: 4rem;

  span {
    color: #ffd700;
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const FeatureContent = styled(motion.div)`
  padding: 2rem;
`;

const FeatureTitle = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 2.5rem;
  color: #ffd700;
  margin-bottom: 1.5rem;
`;

const FeatureDescription = styled.p`
  color: #b0b0b0;
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 2rem;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
`;

const FeatureItem = styled.li`
  color: #ffffff;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;

  &:before {
    content: "✨";
    margin-right: 1rem;
    font-size: 1.2rem;
  }
`;

const FeatureImage = styled(motion.div)`
  width: 100%;
  height: 400px;
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.1) 0%,
    rgba(255, 165, 0, 0.1) 100%
  );
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 6rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`;

const Features = () => {
  return (
    <FeaturesSection id="features">
      <Container>
        <SectionTitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Why Choose <span>Ferman</span>?
        </SectionTitle>

        <FeaturesGrid>
          <FeatureContent
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <FeatureTitle>Luxury Learning Experience</FeatureTitle>
            <FeatureDescription>
              Experience language learning redefined with our premium platform
              designed for discerning learners.
            </FeatureDescription>
            <FeatureList>
              <FeatureItem>AI-Powered Personal Tutors</FeatureItem>
              <FeatureItem>Real-time Accent Coaching</FeatureItem>
              <FeatureItem>Exclusive Learning Materials</FeatureItem>
              <FeatureItem>24/7 VIP Support</FeatureItem>
            </FeatureList>
          </FeatureContent>

          <FeatureImage
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            🎓
          </FeatureImage>
        </FeaturesGrid>
      </Container>
    </FeaturesSection>
  );
};

export default Features;
